import { DatePicker } from 'antd';
import { media } from 'src/utils/mediaQueryUtils';
import styled from 'styled-components';

export const StyledRangePicker = styled(DatePicker.RangePicker)<{
  isActive: boolean;
}>`
  width: 100%;

  ${media.small`
    width: 110px;
    height: 18px;
    border-radius: 4px;
  `}
  ${media.extraLarge`
    width: 230px;
    height: 31px;
    border-radius: 8px;
  `}

  .ant-picker-input > input {
    ${media.small`
      font-weight: 400;
      font-size: 8px;
    `}
    ${media.extraLarge`
      font-weight: 500;
      font-size: 12px;
    `}
  }
  .ant-picker-range {
    ${media.small`
      padding: 2px 7px 2px;
    `}
    ${media.extraLarge`
      padding: 4px 11px 4px;
    `}
  }
  .ant-picker-range-separator {
    ${media.small`
      padding: 0px !important;
      transform: scale(0.7);
    `}
    ${media.extraLarge`
      padding: 0 8px !important;
      transform: scale(1);
    `}
  }
  .ant-picker-suffix {
    ${media.small`
      transform: scale(0.7);
    `}
    ${media.extraLarge`
      transform: scale(1);
    `}
  }

  ${props =>
    props.isActive
      ? `background-color: ${props.theme.colors.individualDashboardTimeButtonBackgroundActive};`
      : ''}
`;
